import { COMPETENCIES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import competenciesTypes from '../../constants/competenciesTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'


//
const get_competency_request = () => {
  return {
    type: competenciesTypes.get.request
  }
}

const get_competency_success = (response) => {
  return {
    type: competenciesTypes.get.request,
    payload: response.data.competency
  }
}

const get_competency_failure = (messages) => {
  return {
    type: competenciesTypes.get.failure,
    payload: messages
  }
}

const get_competency = (competency_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_competency_request())

    // Request
    axios.get(
      formatRoute(COMPETENCIES_ROUTES.get, {id: competency_id})
    ).then( response => {
      // success

      dispatch( get_competency_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching competency."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_competency_failure(errors))
    })
  }

}

export {
  get_competency
}



// WEBPACK FOOTER //
// ./src/js/actions/competencies/get.js